// extracted by mini-css-extract-plugin
export var cardTitle = "_is-1";
export var commentBubble = "_is-e";
export var commentForm = "_is-a";
export var commentInput = "_is-b";
export var commentLabel = "_is-d";
export var commentPrompt = "_is-9";
export var csatCard = "_is-0";
export var feedbackSection = "_is-7";
export var starDisabled = "_is-6";
export var starEmpty = "_is-5";
export var starFilled = "_is-4";
export var starWrapper = "_is-3";
export var starsContainer = "_is-2";
export var submittedComment = "_is-c";
export var thankYouText = "_is-8";